import React, { useState, useEffect } from "react"
import HandyCard from '../../HandyCard/HandyCard';
import { Button, TextField, InputAdornment, FormControl, InputLabel, Select, MenuItem, Pagination } from '@mui/material';
import axios from 'axios'
import moment from 'moment'
import { APIURL } from '../../../config'
import dd from '../../../manifestdd.json'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Icon from '@mui/material/Icon';
import IconButton from "@mui/material/IconButton";
import Modal from '@mui/material/Modal';
import NoteFormv2 from '../../../components/forms/NoteForm/NoteFormv2'
import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import './Notesv2.css'
import { Component } from 'react';
import { ConstructionOutlined } from "@mui/icons-material";
import { display } from "@mui/system";
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/styles'
import MUIRichTextEditor from 'mui-rte';
import MessagePage from '../../../components/MessagePages/MessagePage';

const myTheme = createTheme({
    overrides: {
        MUIRichTextEditor: {
            anchorLink: {
                color: "lightblue",
                textDecoration: "underline",
            },
        },
    },
});

export default function Notesv2(props) {
    var Buffer = require('buffer/').Buffer;

    const [noteList, setNoteList] = useState([])
    const [displayNotes, setDisplayList] = useState([])
    const [filter, setFilter] = useState([])
    const [filterModalOpen, setFilterModalOpen] = useState(false)
    const [editNote, setEditNote] = useState(null)
    const [showAddNote, setShowAddNote] = useState(false)
    const [showAddVoiceNote, setShowAddVoiceNote] = useState(false)
    const [isAdding, setIsAdding] = useState(false)
    const [empList, setEmpList] = useState([])
    const [typeList, setTypeList] = useState([])
    const [content, setContent] = useState([])
    const [isLoading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const notesPerPage = 10;
    const [isNoteDirty, setIsNoteDirty] = useState(false);
    const [showExitConfirm, setShowExitConfirm] = useState(false);

    const closeForm = () => {
        setEditNote(null);
        setShowAddNote(false);
        setShowAddVoiceNote(false);
        setIsAdding(false);
        setIsNoteDirty(false);
        setShowExitConfirm(false);
    };
    const handleFormClose = () => {
        if (isNoteDirty) setShowExitConfirm(true);
        else closeForm();
    };
    const handleDiscard = () => closeForm();
    const handleCancelDiscard = () => setShowExitConfirm(false);
    const handleFormSubmit = () => { fetchData(); closeForm(); };

    const [errorAlert, setErrorAlert] = useState('')
    const handleErrorAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorAlert('')
    }

    const [successAlert, setSuccessAlert] = useState('')
    const handleSuccessAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessAlert('')
    }

    const [searchTerm, setSearchTerm] = useState('');

    const searchNoteHandler = (e) => {
        setSearchTerm(e.target.value);
    }

    const searchNoteResults = (e) => {
        e.preventDefault();
        const regex = new RegExp(searchTerm, 'i');
        let results = noteList.filter(note =>
            regex.test(note.note_title || '') ||
            regex.test(note.tas_title || '') ||
            regex.test(note.tas_type || '') ||
            regex.test(note.emp_first_name || '') ||
            regex.test(note.emp_last_name || '')
        );
        setDisplayList(results);
        generateNoteCards(results);
    }

    async function fetchData() {
        const response = await axios.get(APIURL + `/comments`, {
            params: { pro_id: props.pro_id, empID: props.user?.emp_id }
        })
        let notes = response.data

        notes = await Promise.all(notes.map(async (note) => {
            const noteDataResponse = await axios.get(APIURL + `/comments/details`, {
                params: { comment_id: note.comment_id, empID: props.user?.emp_id }
            })
            const noteData = noteDataResponse.data[0]
            return noteData
        }))

        notes = notes.filter((note) => note !== undefined);

        const audioResp = await axios.get(APIURL + `/audio_note`, {
            params: { project_id: props.pro_id },
        });

        let audioNotes = audioResp.data.map((audioNote) => ({
            ...audioNote,
            created_at: audioNote.submitted,
        }));

        notes.push(...audioNotes)

        notes.sort((a, b) => {
            return moment(a.created_at).isBefore(moment(b.created_at)) ? 1 : -1;
        })
        setFilter({ class: null, specifier: null })
        setNoteList(notes)
        setDisplayList(notes)
        setLoading(false);
    }

    useEffect(() => {
        fetchData();
    }, [])

    useEffect(() => {
        fetchData();
    }, [showAddNote, editNote]);

    useEffect(() => {
        async function loadEmployees() {
            const allEmployees = await axios.get(APIURL + '/dropdowns/dropdownType/employeeslist', { params: { comp_id: props.user.comp_id } });
            let empLs = allEmployees.data.map((emp) => <MenuItem key={emp.id} value={emp.id}>{emp.employee_name}</MenuItem>)
            let typeLs = dd.generic.employeeType.map((type) => <MenuItem key={type.value} value={type.value}>{type.value}</MenuItem>)
            setEmpList(empLs)
            setTypeList(typeLs)
        }
        loadEmployees();
    }, [displayNotes])

    useEffect(() => {
        setPage(1);
        generateNoteCards(displayNotes);
    }, [displayNotes]);

    function filterBy() {
        let noteArr = noteList
        if (filter.class === 'Employee Type') {
            noteArr = noteArr.filter((note) => note.emp_type === filter.specifier)
        } else if (filter.class === 'Employee') {
            noteArr = noteArr.filter((note) => Number(filter.specifier) === note.emp_id[0])
        } else if (filter.class === 'All') {
            noteArr = noteArr.filter((note) => !note.isDeleted)
        }
        setDisplayList(noteArr)
        setFilter({ class: null, specifier: null })
    }

    function filterHandler(e) {
        let id = e.target.id
        let val = e.target.value
        if (id === 'filter1') {
            setFilter({ class: val, specifier: null })
        } else {
            setFilter({ class: filter.class, specifier: val })
        }
    }

    function sortBy(param) {
        const listToSort = [...displayNotes];
        let sortedList;
        if (param === 'dateAsce') {
            sortedList = listToSort.sort((a, b) => moment(a.created_at) - moment(b.created_at));
        } else if (param === 'dateDsce') {
            sortedList = listToSort.sort((a, b) => moment(b.created_at) - moment(a.created_at));
        } else {
            sortedList = listToSort;
        }
        setDisplayList(sortedList);
        generateNoteCards(sortedList);
    }

    function isJSON(str) {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }

    const generateNoteCard = (note) => {
        let audioSrc;

        if (note.audio_note) {
            const decodedData = Buffer.from(note.audioNote[0].audio_note, 'base64');

            const blob = new Blob([decodedData], { type: 'audio/wav' });

            audioSrc = URL.createObjectURL(blob);
        }

        return (
            <Card sx={{ marginBottom: '20px', width: '100%', maxWidth: 'none' }}>
                <CardActions sx={{ paddingLeft: '16px', paddingRight: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: 0 }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ minWidth: 0 }}>
                                    {note.note_title && <h6 style={{ marginBottom: '0px', marginRight: 10, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{note.note_title}</h6>}
                                    {!note.note_title ?
                                        <h6 style={{ marginBottom: '0px', marginRight: 10, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{note.tas_title ? note.tas_title : note.pro_title ? note.pro_title : note.cus_name}</h6> :
                                        <p style={{ marginBottom: '0px', color: 'gray', fontSize: 13 }}>{note.tas_title ? note.tas_title : note.pro_title ? note.pro_title : note.cus_name}</p>
                                    }
                                    <span style={{ display: 'block', color: 'gray', fontSize: 13, marginBottom: 0, marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {note.tas_type}
                                    </span>
                                </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 20 }}>
                                <div style={{ fontSize: 13, color: 'gray', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: 8 }}>
                                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {moment(note.created_at).format('MM/DD/YYYY hh:mm A')} created by {note.emp_first_name + ' ' + note.emp_last_name} ({note.emp_type})
                                    </span>
                                    {!!note.updated_by && !!note.updated_at &&
                                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {moment(note.updated_at).format('MM/DD/YYYY hh:mm A')} updated by {note.updated_emp_first_name + ' ' + note.updated_emp_last_name}
                                        </span>
                                    }
                                </div>
                                {!note.audioNote &&
                                    <IconButton
                                        style={{ marginLeft: 0 }}
                                        onClick={() => {
                                            setEditNote(note)
                                        }}
                                    >
                                        <Icon style={{ fontSize: '16px' }} baseClassName="fas" className="fa-edit" />
                                    </IconButton>
                                }
                            </div>
                        </div>
                    </div>
                </CardActions>
                <CardContent sx={{ paddingBottom: '0px', paddingTop: '0px' }}>
                    <hr style={{ marginBottom: '10px', marginTop: '0px', backgroundColor: '#e2ecfa' }}></hr>
                    {!note.audioNote &&
                        <ThemeProvider theme={myTheme}>
                            <MUIRichTextEditor
                                defaultValue={isJSON(note.comment_text) ? note.comment_text : `{"blocks":[{"key":"block1","text":"${note.comment_text.replace(/\n/g, ' ').replace(/\t/g, ' ').replace(/"/g, '\\"')}","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`}
                                readOnly={true}
                                toolbar={false}
                            />
                        </ThemeProvider>}
                    {note.audioNote && <audio controls src={audioSrc} />}
                </CardContent>
            </Card>
        );
    }

    const generateNoteCards = (noteList) => {
        let nonEmptyNoteList = noteList.filter((note) => note.comment_text !== "")
        let cards = []
        cards = nonEmptyNoteList.map((note) => {
            return generateNoteCard(note)
        })
        setContent(cards)
    }

    const handleExitConfirmClose = () => {
        setShowExitConfirm(false);
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <form style={{ width: '135%' }} onSubmit={searchNoteResults}>
                        <TextField
                            onChange={searchNoteHandler}
                            value={searchTerm}
                            placeholder="Search"
                            variant="outlined"
                            size="small"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton type="submit">
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            style={{ width: '50%' }}
                        />
                        <Button variant="contained" color="primary" disabled={isAdding} style={{ marginLeft: '10px', height: '40px' }} onClick={() => { setIsAdding(true); setShowAddNote(true); }}>
                            Add Note
                        </Button>
                        <Button variant="contained" color="primary" disabled={isAdding} style={{ marginLeft: '10px', height: '40px' }} onClick={() => { setIsAdding(true); setShowAddNote(true); setShowAddVoiceNote(true); }}>
                            Add Voice Note
                        </Button>
                    </form>
                </div>
                <div style={{ display: 'flex', justifyContent: 'start' }}>
                    <Button variant="outlined" color="primary" style={{ height: '40px' }} onClick={() => setFilterModalOpen(true)}>
                        <i className="fas fa-filter" style={{ marginRight: 4 }}></i> FILTER
                    </Button>
                    <div className="dropdown">
                        <button
                            style={{ outline: 'none', color: '#1976D2', border: '1px solid #1976D2', height: '40px' }}
                            className="btn btn-sm dropdown-toggle bg-white" type="button" id="dropdownSortBy" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                            <span><i className="fas fa-sort-amount-up"></i></span> SORT BY
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownSortBy">
                            <button onClick={() => sortBy('dateDsce')} className="dropdown-item" type="button">Latest</button>
                            <button onClick={() => sortBy('dateAsce')} className="dropdown-item" type="button">Oldest</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='tasks_info' style={{ marginTop: '10px' }}>
                <div style={{ marginBottom: '10px' }}>
                    <h5 style={{ margin: 0 }}>Notes</h5>
                </div>
                {isLoading ? (
                    <div className='d-flex flex-row w-100 justify-content-center mt-5'>
                        <div className="spinner-border text-primary" role="status"></div>
                    </div>
                ) : displayNotes.length === 0 ? (
                    <MessagePage title="No Notes were found" icon="far fa-sticky-note" />
                ) : (
                    <> 
                        <div style={{ overflow: 'scroll', height: 'calc(100vh - 400px)', paddingBottom: '10px' }}>
                            {content.slice((page - 1) * notesPerPage, page * notesPerPage)}
                        </div>
                        <div style={{  background: '#F9F9F9', display: 'flex', justifyContent: 'center' }}>
                            <Pagination count={Math.ceil(content.length / notesPerPage)} page={page} onChange={(e, v) => setPage(v)} color="primary" />
                        </div>
                    </>
                )}
            </div>
            <Dialog open={filterModalOpen} onClose={() => setFilterModalOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    Filter By
                    <IconButton onClick={() => setFilterModalOpen(false)} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: '16px', marginTop: '8px' }}>
                        <InputLabel id="filter1-label">Class</InputLabel>
                        <Select
                            labelId="filter1-label"
                            label="Class"
                            value={!filter.class ? '' : filter.class}
                            onChange={(e) => setFilter({ class: e.target.value, specifier: null })}
                        >
                            <MenuItem value="">Select Class</MenuItem>
                            <MenuItem value="All">All</MenuItem>
                            <MenuItem value="Employee Type">Employee Type</MenuItem>
                            <MenuItem value="Employee">Employee</MenuItem>
                        </Select>
                    </FormControl>
                    {!!filter.class && filter.class !== 'All' && (
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="filter2-label">Specify</InputLabel>
                            <Select
                                labelId="filter2-label"
                                label="Specify"
                                value={!filter.specifier ? '' : filter.specifier}
                                onChange={(e) => setFilter({ ...filter, specifier: e.target.value })}
                            >
                                <MenuItem value="">Select Specifier</MenuItem>
                                {filter.class === 'Employee Type' && typeList}
                                {filter.class === 'Employee' && empList}
                            </Select>
                        </FormControl>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => { filterBy(); setFilterModalOpen(false); }}>Save</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth={true} maxWidth={'lg'} open={editNote != null}>
                <DialogActions>
                    <IconButton onClick={handleFormClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogActions>
                <DialogContent sx={{ paddingTop: '0px' }}>
                    <NoteFormv2
                      mode='edit'
                      checkTokenExpiry={props.checkTokenExpiry}
                      task_id={editNote?.tas_id}
                      note_id={editNote?.comment_id}
                      user={props.user}
                      project_id={props.pro_id}
                      company_id={props.user.comp_id}
                      onSubmit={handleFormSubmit}
                      onDirtyChange={setIsNoteDirty}
                    />
                </DialogContent>
            </Dialog>
            <Dialog fullWidth={true} maxWidth={'lg'} open={showAddNote} >
                <DialogActions>
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.25 }}
                        onClick={handleFormClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogActions>
                <DialogContent sx={{ paddingTop: '0px' }}>
                    <NoteFormv2 checkTokenExpiry={props.checkTokenExpiry} company_id={props.user.comp_id} mode='add' isVoiceNote={showAddVoiceNote} user={props.user} project_id={props.pro_id} onSubmit={handleFormSubmit} onDirtyChange={setIsNoteDirty}></NoteFormv2>
                </DialogContent>
            </Dialog>
            <Dialog
                open={showExitConfirm}
                onClose={handleCancelDiscard}
            >
                <DialogTitle>Discard Changes?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        You have unsaved changes. Are you sure you want to discard them?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelDiscard}>Cancel</Button>
                    <Button onClick={handleDiscard} color='primary'>Discard</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}